document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("click", function (e) {

    const thumb = e.target.closest(".variant-thumb");

    if (!thumb) return;

    const color = thumb.dataset.color;

    const radios = document.querySelectorAll(
      ".native-color-picker input[type='radio']"
    );

    radios.forEach((radio) => {

      if (radio.value.trim() === color.trim()) {

        const label = document.querySelector(
          'label[for="' + radio.id + '"]'
        );

        if (label) {
          label.click();   // <-- Let Craft handle everything
        }

      }

    });

  });

});